import wrapperHOC from "@Utils/wrapperHOC";

const RatingStarOutline = ({ size = 32 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size - 2}
    viewBox="0 0 32 30"
    fill="none"
  >
    <path
      d="M15.994 25.541L7.85993 29.8301C7.43493 30.082 6.85646 30.041 6.41375 29.7305C5.97694 29.4199 5.75854 28.8809 5.79396 28.3535L7.39361 19.2422L0.836214 12.7852C0.454894 12.416 0.319721 11.8594 0.487359 11.3496C0.654408 10.8457 1.09535 10.4766 1.62601 10.4004L10.6697 9.07031L14.719 0.792188C14.961 0.307559 15.4509 0 15.994 0C16.537 0 17.0328 0.307617 17.269 0.792188L21.3183 9.07031L30.3672 10.4004C30.8985 10.4766 31.3353 10.8457 31.5065 11.3496C31.6717 11.8594 31.536 12.416 31.1582 12.7852L24.5943 19.2422L26.1467 28.3535C26.2353 28.8809 26.0169 29.4199 25.5742 29.7305C25.1374 30.041 24.5058 30.082 24.0808 29.8301L15.994 25.541ZM12.3697 9.89062C12.0981 10.4473 11.5669 10.834 10.9471 10.9277L2.83607 12.1172L8.72764 17.9062C9.15854 18.334 9.35923 18.9492 9.25889 19.5527L7.86583 27.7266L15.1026 23.8887C15.6634 23.5898 16.3304 23.5898 16.8853 23.8887L24.1221 27.7266L22.7349 19.5527C22.6287 18.9492 22.8294 18.334 23.2662 17.9062L29.1572 12.1172L21.0408 10.9277C20.3738 10.834 19.8426 10.4473 19.6183 9.89062L15.994 2.47969L12.3697 9.89062Z"
      fill="#D1D5DB"
      style={{ fill: "#D1D5DB", fillOpacity: 1 }}
    />
  </svg>
);

export default wrapperHOC(RatingStarOutline, {
  componentName: "RatingStarOutline-icons",
  showForChina: true,
});
